export default "__VITE_ASSET__pk30tOhn__"